import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import { SET as SET_VERSION } from './version'

export const NAMESPACE = 'KanBo/localSettings/'
export const ADD = NAMESPACE + 'ADD'
export const REMOVE = NAMESPACE + 'REMOVE'

const initialState = {}

export function reducer (state = initialState, action = {}) {
  switch (action.type) {
    case SET_VERSION:
      return action.payload.changed ? {} : state
    case ADD:
      return {
        ...state,
        [action.payload.id]: action.payload.value
      }
    case REMOVE: return !state[action.payload.id] ? state : (() => {
      const newState = {
        ...state
      }

      delete newState[action.payload.id]

      return newState
    })()
    default: return state
  }
}

export function add ({ id, value }) {
  return {
    type: ADD,
    payload: {
      id,
      value
    }
  }
}

export function remove ({ id }) {
  return {
    type: REMOVE,
    payload: {
      id
    }
  }
}

export default persistReducer({ key: 'localSettings', storage }, reducer)
